import React from 'react';
import * as XLSX from 'xlsx';

const DailyVolumeF4 = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const dailyVolume = inspectionData.dailyVolumeQualifiedModules;

  if (!dailyVolume || !dailyVolume.lines) {
    return <p className="text-gray-500">No Daily Volume F4 data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
    //   'Date',
    //   'Shift',
      'Line',
      'Layup - Start Serial No',
      'Layup - End Serial No',
      'Layup - Total Qty',
      'Wattage Peak',
      'Packed Quantity - Quantity',
      'Packed Quantity - MWp',
      'Packed Quantity - Cumulative MWp',
    ]);

    // Populate data for each line and wattage peak
    dailyVolume.lines.forEach((lineData) => {
      Object.entries(lineData.packedQuantity).forEach(([wpKey, wpData]) => {
        worksheetData.push([
        //   dailyVolume.date,
        //   dailyVolume.shift,
          lineData.line,
          lineData.layup.startSerialNo || 'N/A',
          lineData.layup.endSerialNo || 'N/A',
          lineData.layup.totalQty || 'N/A',
          wpKey,
          wpData.quantity || 'N/A',
          wpData.MWp || 'N/A',
          wpData.cumulativeMWp || 'N/A',
        ]);
      });
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DailyVolumeF4');
    XLSX.writeFile(workbook, 'DailyVolumeF4Data.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">
          Daily Volume - {dailyVolume.date} ({dailyVolume.shift})
        </h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>
      {dailyVolume.lines.map((lineData, index) => (
        <div key={index} className="border-b pb-4">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">{lineData.line}</h3>

          {/* Layup Section */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Layup</h4>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Start Serial No</th>
                    <th className="px-4 py-2 text-left text-gray-700">End Serial No</th>
                    <th className="px-4 py-2 text-left text-gray-700">Total Qty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">{lineData.layup.startSerialNo || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.layup.endSerialNo || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.layup.totalQty || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Packed Quantity Section */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Packed Quantity</h4>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Wattage Peak</th>
                    <th className="px-4 py-2 text-left text-gray-700">Quantity</th>
                    <th className="px-4 py-2 text-left text-gray-700">MWp</th>
                    <th className="px-4 py-2 text-left text-gray-700">Cumulative MWp</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(lineData.packedQuantity).map(([wpKey, wpData]) => (
                    <tr key={wpKey} className="border-t">
                      <td className="px-4 py-2 text-gray-600">{wpKey}</td>
                      <td className="px-4 py-2 text-gray-600">{wpData.quantity || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{wpData.MWp || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{wpData.cumulativeMWp || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DailyVolumeF4;